import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.5 1C17.567 1 16 2.567 16 4.5C16 6.08551 17.0543 7.42479 18.5 7.85506V9.99996C18.5 10.5522 18.0523 11 17.5 11H6.5C5.94772 11 5.5 10.5522 5.5 9.99996L5.5 7.85506C6.94574 7.42479 8 6.08551 8 4.5C8 2.567 6.433 1 4.5 1C2.567 1 1 2.567 1 4.5C1 6.08551 2.05425 7.42479 3.5 7.85506V9.99996C3.5 11.6568 4.84315 13 6.5 13H11L11 16.1449C9.55426 16.5752 8.5 17.9145 8.5 19.5C8.5 21.433 10.067 23 12 23C13.933 23 15.5 21.433 15.5 19.5C15.5 17.9145 14.4457 16.5752 13 16.1449L13 13H17.5C19.1569 13 20.5 11.6568 20.5 9.99996V7.85506C21.9457 7.42479 23 6.08551 23 4.5C23 2.567 21.433 1 19.5 1Z"}}]};

const ForkFilled = Vue.extend<IconProps>({
  name: 'ForkFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fork-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ForkFilled;
